var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseTable", {
    staticClass: "custom-table",
    attrs: { tableClass: "table-bordered", hidePagination: "" },
    scopedSlots: _vm._u([
      {
        key: "thead",
        fn: function() {
          return [
            _c("thead", [
              _c("tr", [
                _c("th", [
                  _vm._v(_vm._s(_vm.$t("apps.billing.label.invoiceno")))
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "text-center" }, [
                  _vm._v(_vm._s(_vm.$t("apps.billing.label.datemonth")))
                ]),
                _vm._v(" "),
                _c("th", { staticClass: "text-right" }, [
                  _vm._v(_vm._s(_vm.$t("apps.billing.label.payamount")))
                ])
              ])
            ])
          ]
        },
        proxy: true
      },
      {
        key: "tbody",
        fn: function() {
          return [
            _c("tbody", [
              _c("tr", [
                _c(
                  "td",
                  [
                    _c(
                      "RouterLinkCustom",
                      {
                        attrs: {
                          status: {
                            color: _vm.linkIcon,
                            text: _vm.linkIconTooltipText,
                            type: "icon"
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.invoice.code) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { staticClass: "text-center" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.datePeriodText) + "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "text-right" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.getCurrencyWithNumber(
                          _vm.numberel(_vm.invoice.total, "0,0.00")
                        )
                      ) +
                      "\n        "
                  )
                ])
              ])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5483b43c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5483b43c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/InvoiceListTable.vue
// module id = null
// module chunks = 